import React from "react"
import { Formik, Form as FormikForm, Field } from "formik"
import { Row, Form, Col } from "react-bootstrap"
import * as Yup from "yup"
// import format from "date-fns/format"
import NumberFormat from "react-number-format"
import FormTextbox from "../../shared/formTextbox"
import FormFieldDisableAutoComplete from "../../shared/formFieldDisableAutoComplete"
import FormDatePickerTextBox from "../../shared/formDatePickerTextBox"
import FormTimeTextBox from "../../shared/formTimeTextBox"
import FormAmountTextBox from "../../shared/formAmountTextBox"
import FormDropdownList from "../../shared/formDropdownList"
import FormEditUpload from "../../shared/formEditUpload"
import { fillOtherBenefitsAlert } from "../../../services/sweetalertService"

import {
  controlEditBenefit,
  updateValidBenfitFormData,
  updateClickedNext,
  updateFormIsValid,
  pageIncrement,
  completeBenefitForm,
  addBenefitItem,
} from "../../../redux/actions"

import * as Constants from "../../../common/constants"
import * as Regex from "../../../common/regex"
import * as ErrorMessage from "../../../common/errorMessage"
import * as CommonFunction from "../../../common/function"
import * as Alert from "../../../services/sweetalertService"

import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"

const OtherBenefitsForm = ({ coverageDetail }) => {
  const dispatch = useDispatch()
  const formRef = React.useRef()

  const {
    editBenefits,
    allProofDocuments,
    claimUploadListModel,
    clickedNext,
    tempBenefitInfo,
    pageNumber,
    chosenedBenefits,
  } = useSelector(state => state.uiData)

  const claimData = useSelector(state => state.claimData, shallowEqual)

  const {
    Category: coverageCategory,
    CoverageCode: coverageCode,
    CoverageDetailId: coverageDetailId,
    CoverageDetailName: coverageDetailName,
  } = coverageDetail

  const formName = coverageCode

  //PA dropdown data
  const { OtherBenefits } = useSelector(state => state.dropdownData)

  const [otherBenefitsList, setOtherBenefitsList] = React.useState([])

  useSelector(state => {
    if (!state.claimData[coverageCategory][coverageCode]) {
      state.claimData[coverageCategory][coverageCode] = {}
    }
  }, shallowEqual)

  const validationSchema = Yup.object().shape({
    occurrenceDate: Yup.date().required(ErrorMessage.OtherBenefitsAccidentDate),
    occurrenceTime: Yup.string()
      .required(ErrorMessage.OtherBenefitsAccidentTime)
      .matches(Regex.timepattern, ErrorMessage.OtherBenefitsAccidentTime)
      .test("occurrenceTime", ErrorMessage.futureTimeErrorMsg, value => {
        return CommonFunction.notFutureDatime(
          formRef.current.values.occurrenceDate,
          value
        )
      }),

    occurrenceLocation: Yup.string().required(
      ErrorMessage.OtherBenefitsAccidentLocation
    ),

    occurrenceDescription: Yup.string().required(
      ErrorMessage.OtherBenefitsAccidentDescription
    ),

    claimAmount: Yup.number()
      .transform(value => (isNaN(value) ? undefined : value))
      .min(1, ErrorMessage.claimAmount),
  })

  const updateBenefitClaimAmount = otherBenefitsList => {
    let totalAmount = 0

    otherBenefitsList.forEach((otherListItem, medicalListKey) => {
      totalAmount += otherListItem.claimAmount
    })

    return totalAmount
  }

  function addOtherBenefitsEvent(values) {
    if (
      (values.benefitClaimed !== "Other" ||
        (values.benefitClaimed === "Other" &&
          values.benefitClaimedOther &&
          values.benefitClaimedOther.trim())) &&
      values.benefitClaimed &&
      values.netClaimAmount &&
      values.netClaimAmount >= 1
    ) {
      let copyOfOtherBenefitsList = Object.assign([], otherBenefitsList)
      let index = new Date().getTime().toString()

      copyOfOtherBenefitsList.push({
        index: index,
        benefitClaimed:
          values.benefitClaimed === "Other"
            ? values.benefitClaimedOther
            : values.benefitClaimed,
        claimAmount: values.netClaimAmount,
      })

      setOtherBenefitsList(copyOfOtherBenefitsList)

      formRef.current.setFieldValue("benefitClaimed", "")
      formRef.current.setFieldValue("benefitClaimedOther", "")
      formRef.current.setFieldValue("netClaimAmount", 0)
      formRef.current.setFieldValue(
        "claimAmount",
        updateBenefitClaimAmount(copyOfOtherBenefitsList)
      )
    } else {
      fillOtherBenefitsAlert()
    }
  }

  function removeOtherBenefitsEvent(index) {
    let copyOfOtherBenefitsList = Object.assign([], otherBenefitsList)
    let indexToRemove = copyOfOtherBenefitsList.findIndex(
      x => x.index === index
    )
    copyOfOtherBenefitsList.splice(indexToRemove, 1)
    setOtherBenefitsList(copyOfOtherBenefitsList)
    formRef.current.setFieldValue(
      "claimAmount",
      updateBenefitClaimAmount(copyOfOtherBenefitsList)
    )
  }

  return (
    <Formik
      initialValues={Object.assign(
        {
          occurrenceDate: "",
          occurrenceTime: "",
          occurrenceLocation: "",
          occurrenceDescription: "",
          deathDate: "",
          deathTime: "",
          deathNatureType: "",
          deathNature: "",
          otherPartyName: "",
          otherPartyPolicyNumber: "",
          otherPartyDescription: "",
          childName: "",
          childBirthDate: "",
          childNRIC: "",
          claimAmount: 0,
        },
        claimData[coverageCategory][coverageCode]
      )}
      // enableReinitialize={true}
      validationSchema={validationSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {}}
    >
      {({ handleSubmit, values }) => (
        <>
          <FormikForm onSubmit={handleSubmit}>
            {
              <Row
                className={
                  "form-group " + (editBenefits[coverageCode] ? "" : "hide")
                }
              >
                <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                  <p>{coverageDetailName}</p>
                </div>
                <div className="col-md-3 col-5 marginTop10px">
                  <div
                    className="cursorPointer"
                    role="button"
                    tabIndex="0"
                    onClick={() => dispatch(controlEditBenefit(coverageCode))}
                  >
                    <p className="doneEdit">DONE EDIT</p>
                  </div>
                </div>
              </Row>
            }
            {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
            <Field
              textDesc={"Disable Auto Complete"}
              name="disableAutoComplete"
              component={FormFieldDisableAutoComplete}
            />
            <Field
              textDesc={"Date of Accident"}
              name="occurrenceDate"
              component={FormDatePickerTextBox}
            />

            <Field
              textDesc="Time of Accident (HH:mm)"
              name="occurrenceTime"
              component={FormTimeTextBox}
            />

            <Field
              textDesc={"Location of Accident"}
              maxLength={100}
              name="occurrenceLocation"
              component={FormTextbox}
            />

            <Field
              textDesc={"Description of Accident"}
              maxLength={3000}
              name="occurrenceDescription"
              component={FormTextbox}
            />

            {/* Add / Remove Benefits */}
            <Form.Group>
              <Row>
                <Col className="font-weight-bold">{"Add Benefits"}</Col>
              </Row>
            </Form.Group>
            <Field
              textDesc="Benefit Claimed"
              name="benefitClaimed"
              component={FormDropdownList}
              dropdownItem={OtherBenefits}
            />
            {values.benefitClaimed && values.benefitClaimed === "Other" && (
              <>
                {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                <Field
                  textDesc={"Disable Auto Complete"}
                  name="disableAutoComplete2"
                  component={FormFieldDisableAutoComplete}
                />
                <Field
                  textDesc="Please specify benefit claimed"
                  name="benefitClaimedOther"
                  component={FormTextbox}
                  maxLength={200}
                />
              </>
            )}

            <Field
              textDesc="Claim Amount"
              name="netClaimAmount"
              component={FormAmountTextBox}
              maxLength={14}
            />
            <Form.Group>
              <Row>
                <Col md="7" lg="7" className="textforinput marginTop10px">
                  <p className={otherBenefitsList.length > 0 ? "" : "hide"}>
                    <b>{"Other Benefits"}</b>
                  </p>
                </Col>
                <Col
                  md="5"
                  lg="5"
                  className="marginTop10px"
                  id="divDescMake"
                  align="right"
                  style={{ lineHeight: "50px" }}
                >
                  <div
                    className="btn btn-success btn-round btnAddItem"
                    onClick={addOtherBenefitsEvent.bind(this, values)}
                    onKeyDown={addOtherBenefitsEvent.bind(this, values)}
                    style={{ width: "80%" }}
                    tabIndex="0"
                    role="button"
                  >
                    <span id="btnAddItem">
                      <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                      &nbsp;Add
                    </span>
                  </div>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <Row className={otherBenefitsList.length > 0 ? "" : "hide"}>
                <Col className="table-responsive">
                  <table className="table">
                    <tbody>
                      <tr>
                        <th className="text-center" scope="col">
                          Benefit Claimed
                        </th>
                        <th className="text-center" scope="col">
                          Claim Amount
                        </th>
                        <th className="text-center" scope="col">
                          Remove
                        </th>
                      </tr>
                      {otherBenefitsList.map(item => (
                        <tr key={item.index}>
                          <td className="text-center">{item.benefitClaimed}</td>
                          <td className="text-center">
                            <NumberFormat
                              value={item.claimAmount}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"S$"}
                            />
                          </td>
                          <td className="text-center">
                            <div
                              className="btn btn-danger btn-fab btn-fab-mini btn-round"
                              style={{ paddingTop: "7px" }}
                              onClick={removeOtherBenefitsEvent.bind(
                                this,
                                item.index
                              )}
                              onKeyDown={removeOtherBenefitsEvent.bind(
                                this,
                                item.index
                              )}
                              tabIndex="0"
                              role="button"
                            >
                              <i className="fa fa-minus" aria-hidden="true"></i>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Form.Group>
            {/* END of Add / Remove Benefits */}

            <Field
              disabled={true}
              textDesc={"Amount Claimed(SGD)"}
              maxLength={14}
              name="claimAmount"
              component={FormAmountTextBox}
            />

            <FormEditUpload
              editBenefits={editBenefits[coverageCode]}
              coverageDetailId={coverageDetailId}
              coverageDetailName={coverageDetailName}
              allProofDocuments={allProofDocuments}
              claimUploadListModel={claimUploadListModel}
            />

            <HandleFormValidation
              thisPageClickedNext={clickedNext[Constants.benefitFormPageNumber]}
              reviewPageClickedNext={clickedNext[Constants.reviewPageNumber]}
              formRef={formRef}
              values={values}
              thisPageNumber={Constants.benefitFormPageNumber}
              dispatch={dispatch}
              formName={formName}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              tempBenefitInfo={tempBenefitInfo}
              itemList={otherBenefitsList}
              chosenedBenefits={chosenedBenefits}
            />
            <HandleClaimAmountUpdate
              claimAmount={values.claimAmount}
              dispatch={dispatch}
              pageNumber={pageNumber}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              otherBenefitsList={otherBenefitsList}
              formRef={formRef}
            />
          </FormikForm>
        </>
      )}
    </Formik>
  )
}

const HandleFormValidation = ({
  thisPageClickedNext,
  reviewPageClickedNext,
  formRef,
  values,
  thisPageNumber,
  dispatch,
  formName,
  coverageCategory,
  coverageCode,
  tempBenefitInfo,
  itemList,
  chosenedBenefits,
}) => {
  React.useEffect(() => {
    if (
      (thisPageClickedNext && coverageCode === tempBenefitInfo.CoverageCode) ||
      (reviewPageClickedNext &&
        CommonFunction.checkBenefitChosened(chosenedBenefits, coverageCode))
    ) {
      // console.log(formRef.current)
      formRef.current.validateForm().then(errors => {
        // console.log(errors)

        batch(() => {
          if (Object.entries(errors).length === 0) {
            // console.log("PASS")

            dispatch(
              updateValidBenfitFormData(coverageCategory, coverageCode, values)
            )
            dispatch(
              addBenefitItem(
                coverageCategory,
                coverageCode,
                "OtherItemList",
                itemList
              )
            )
            if (thisPageClickedNext) {
              dispatch(pageIncrement())
              dispatch(completeBenefitForm(coverageCode))
            } else {
              dispatch(updateFormIsValid(formName, true))
            }
          } else {
            if (thisPageClickedNext) {
              Alert.missingInfoAlert()
            } else {
              dispatch(updateFormIsValid(formName, false))
            }
            formRef.current.submitForm() // Set touched to all fields
          }

          dispatch(updateClickedNext(thisPageNumber, false))
        })
      })
    }
  }, [
    thisPageClickedNext,
    reviewPageClickedNext,
    formRef,
    values,
    thisPageNumber,
    dispatch,
    formName,
    coverageCategory,
    coverageCode,
    tempBenefitInfo,
  ])
  return null
}

const HandleClaimAmountUpdate = ({
  claimAmount,
  dispatch,
  pageNumber,
  coverageCategory,
  coverageCode,
  otherBenefitsList,
  formRef,
}) => {
  React.useEffect(() => {
    if (pageNumber === Constants.reviewPageNumber) {
      setTimeout(() => {
        batch(() => {
          dispatch(
            updateValidBenfitFormData(
              coverageCategory,
              coverageCode,
              formRef.current.values
            )
          )
          dispatch(
            addBenefitItem(
              coverageCategory,
              coverageCode,
              "OtherItemList",
              otherBenefitsList
            )
          )
        })
      }, 1000)
    }
  }, [claimAmount])

  return null
}
export default OtherBenefitsForm
